import React, { useEffect, useMemo, useState } from 'react'
import ImagesViewer from './ImagesViewer'
import { Box, CircularProgress, Grid, Paper, Typography } from '@mui/material';
import TitleBar from 'components/TitleBar';
import DocumentList from './DocumentList';
import { useParams } from 'react-router-dom';
import { useGetFoldersQuery, useLazyGetFoldersQuery } from 'store/slices/apis/dmsSlice';
import ImagesFolderList from './ImagesFolderList';

const images = [
    {
        imageUrl: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww",
        name: "Site Image New 1.jpeg",
        caption: "Image Caption",
        id: "ID-1"
    },
    {
        imageUrl: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww",
        name: "Site Image New 2.jpeg",
        caption: "Image Caption",
        id: "ID-2"
    },
    {
        imageUrl: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww",
        name: "Site Image New 3.jpeg",
        caption: "Image Caption",
        id: "ID-3"
    },
    {
        imageUrl: "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y29uc3RydWN0aW9ufGVufDB8fDB8fHww",
        name: "Site Image New 4.jpeg",
        caption: "Image Caption",
        id: "ID-4"
    }
]

const ProjectImages = () => {
    const { projectId } = useParams();
    const { data, isLoading, isError, refetch: refetchRoot } = useGetFoldersQuery({ projectId, parentId: "93631f20-6702-4f49-a15c-e2e150855272" }, {
        refetchOnMountOrArgChange: true,
    });
    const [
        trigger,
        { data: lazyData, isFetching: lazyLoading, isError: lazyError },
    ] = useLazyGetFoldersQuery({ projectId });
    const [folders, setFolders] = useState([]);
    const [selectedFolderId, setSelectedFolderId] = useState("");
    const [selectedDocId, setSelectedDocId] = useState(null);
    const [loadingFolderId, setLoadingFolderId] = useState(null);
    const [filesData, setFilesData] = useState([]);

    const isInitialLoading = isLoading
    const isInitialError = isError
    const isFolderList = !isLoading && !isError;

    const getFiles = (folders, selectedFolderId) => {
        const folder = folders.find(
            (folder) => folder.folderId === selectedFolderId
        );

        if (folder) {
            return folder.files;
        }

        for (const f of folders) {
            if (f.children && f.children.length > 0) {
                const foundedFiles = getFiles(f.children, selectedFolderId);
                if (foundedFiles) {
                    return foundedFiles;
                }
            }
        }

        return null;
    };

    const files = useMemo(() => {
        const allFiles = getFiles(folders, selectedFolderId) || [];
        const list = allFiles.map((item) => ({ ...item, id: item.fileId }));
        // if (!search?.trim()) return list;
        // const q = search.toLowerCase();
        //return list.filter((f) => (f.fileName || "").toLowerCase().includes(q));
    }, [selectedFolderId, folders]);


    const selectedDoc = useMemo(() => {
        const list = files || [];
        return list.find((f) => f.fileId === selectedDocId) || null;
    }, [selectedFolderId, selectedDocId, files]);


    // useEffect(() => {
    //     if (data?.data) {
    //         setFolders((prevFolders) => {
    //             // If totally empty, initialize
    //             if (prevFolders.length === 0) {
    //                 return data.data.filter(item => item.folderId === "93631f20-6702-4f49-a15c-e2e150855272").map((item) => ({ ...item, children: [] }));
    //                 //return data.data.map((item) => ({ ...item, children: [] }));
    //             }

    //             // If we already have folders, merge the root names/files 
    //             // without losing the expanded children
    //             return data.data.map((incoming) => {
    //                 const existing = prevFolders.find((f) => f.folderId === incoming.folderId);
    //                 if (existing) {
    //                     return {
    //                         ...existing,
    //                         folderName: incoming.folderName,
    //                         files: incoming.files,
    //                     };
    //                 }
    //                 return { ...incoming, children: [] };
    //             });
    //         });
    //     }
    // }, [data])
    useEffect(() => {
        if (data?.data) {
            setFolders(data.data);
        }
    }, [data]);

    const replaceNodeById = (nodes, updatedNode) => {
        return nodes.map((node) => {
            if (node.folderId === updatedNode.folderId) {
                return updatedNode;
            }

            if (node.children && node.children.length > 0) {
                return {
                    ...node,
                    children: replaceNodeById(node.children, updatedNode),
                };
            }

            return node;
        });
    };

    const handleFolderClick = async (folder, id) => {
        const folderId = folder?.folderId || id;


        // Stop if leaf
        if (folder?.isLastLeaf) return;

        // Stop if already loaded
        if (folder?.children?.length > 0) return;

        setLoadingFolderId(folderId);

        try {
            const result = await trigger({ projectId, parentId: folderId }).unwrap();

            // console.log("result", result.data)

            const findedNode = result?.data?.find(
                (item) => item.folderId === folderId
            );
            //console.log("result nodes", findedNode)


            if (!findedNode) return;

            setFolders((prev) => replaceNodeById(prev, findedNode));

        } catch (error) {
            console.error("Fetch failed", error);
        } finally {
            setLoadingFolderId(null);
        }
    };

    return (
        <Paper sx={{
            width: "100%",
            pb: 2,
            borderRadius: 2,
            overflow: "auto",
            border: "1px solid #eef0f4",
            boxSizing: "border-box"
        }}>
            <Grid container>
                <TitleBar
                    title="Site Images"
                    description="Check out your site images here."
                />
            </Grid>
            <Grid size={12} container spacing={1.5} sx={{ p: 2 }}>
                <Grid size={5}>
                    {isInitialLoading && <CircularProgress />}
                    {isInitialError && <Typography color="error">Failed to load folders.</Typography>}
                    {isFolderList &&
                        <ImagesFolderList
                            folders={folders}
                            handleFolderClick={handleFolderClick}
                            selectedFolderId={selectedFolderId}
                            setSelectedDocId={setSelectedDocId}
                            loadingFolderId={loadingFolderId}
                            showFiles={false}
                            setSelectedFolderId={setSelectedFolderId}
                            setFilesData={setFilesData}
                        />
                    }
                </Grid>
                <Grid size={7}>
                    <ImagesViewer files={filesData} selectedFolderId={selectedFolderId} />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default ProjectImages
